/**
 * Google reCAPTCHA v3 constants.
 *
 * See docs/security/recaptcha/ for the full feature documentation and the
 * TSD - Google reCAPTCHA requirements traceability.
 */

/** Site preference IDs synced to the storefront via MRT (mrtClientData.js). */
export const RECAPTCHA_PREFERENCE_KEYS = Object.freeze({
  ENABLED: 'GOOGLE_RECAPTCHA_ENABLED',
  SITE_KEY: 'GOOGLE_RECAPTCHA_SITE_KEY',
  SCORE_THRESHOLD: 'GOOGLE_RECAPTCHA_SCORE_THRESHOLD',
});

/** Server endpoint that verifies a reCAPTCHA token (GR-008). */
export const RECAPTCHA_VERIFY_ENDPOINT = '/server/verify-recaptcha';

/**
 * reCAPTCHA action names (GR-004). Actions are reported to Google and visible in
 * the reCAPTCHA admin console for per-action analytics. Keep them stable and
 * descriptive; only use a-z, _, and / per Google's guidance.
 *
 * Scope (confirmed 2026-06): reCAPTCHA is enforced on Registration, the Contact
 * Us / showroom-enquiry form, the JobAdder application form, the checkout
 * newsletter subscription, and the footer newsletter subscription. Login
 * (standalone + checkout) is intentionally NOT verified — see
 * docs/security/recaptcha/implementation.md §"Scope change".
 */
export const RECAPTCHA_ACTIONS = Object.freeze({
  REGISTER: 'register',
  CONTACT: 'contact',
  JOB_APPLICATION: 'job_application',
  CHECKOUT_SUBSCRIPTION: 'checkout_subscription',
  NEWSLETTER: 'newsletter',
});

/** Default score threshold (mirrors the SFCC site preference default, GR-002). */
export const RECAPTCHA_DEFAULT_SCORE_THRESHOLD = 0.5;
